module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.ef67473b.jpeg";